import React, { useRef} from 'react';
import Header from '../Header';
import Footer from '../Footer';
import InvoiceHeroSection from './InvoiceHeroSection';
import InvoiceChooseUsSection from './InvoiceChooseUsSection';
import InvoiceBusinessSection from './InvoiceBusinessSection';
import InvoiceFormSection from './invoiceFormSection';
import usePageTitle from '../../hooks/usePageTitle';


const InvoicegstPage = () => {
    usePageTitle('page-title', 'invoicepage');
    const heroRef = useRef(null);
    const handleClick = () => {
        heroRef.current?.scrollIntoView({behavior: 'smooth'});
    };
    const productType = "Invoice";

    return (
        <>
            <Header />
            <InvoiceHeroSection onScrollToForm={handleClick}/>
            <InvoiceChooseUsSection/>
            <InvoiceFormSection ref={heroRef} productType={productType}/>
            <InvoiceBusinessSection/>
            <Footer />
        </>
    );
}

export default InvoicegstPage;